import { isNullish, isNotNullish } from 'utils/nullish';
import isString from 'lodash/lang/isString';

export const TapdUtil = (function() {
  return Object.freeze({
    // 从tapd缺陷页面地址中读取出bug id。 如果获取不到，返回null
    getBugIdFromUrl(url) {
      if (!isString(url)) {
        return null;
      }
      // 目前已知的TAPD的缺陷页面url有以下形式
      // 1.  /tapd_fe/{项目ID}/bug/list?dialog_preview_id=bug_{缺陷ID}
      // 2.  /{项目name}/bugtrace/bugs/view?bug_id={缺陷ID}
      // 3.  /{项目name}/bugtrace/bugs/view/{缺陷ID}
      // 4.  /tapd_fe/{项目ID}/bug/detail/{缺陷ID}
      const matchResult = url.match(/tapd.+(?:bug_|bug_id=|view\/|bug\/detail\/)(\d+)/);
      if (!matchResult) {
        return null;
      }
      return matchResult[1];
    },

    makeBugUrl(tapdBugInfo, teamType) {
      if (isNullish(tapdBugInfo)) return null;
      let bugUrl = '';
      const { bugPlatform, commercialTapd, workspaceId, id: bugId } = tapdBugInfo;

      // 兼容返回的历史tapd数据不带bugPlatform字段
      const platForm = isNotNullish(bugPlatform)
        ? bugPlatform
        : 'TAPD';

      // 兼容以前bug数据里面没有commercialTapd字段，没有这个字段的用teamType判断
      const isCommercialTapd = isNotNullish(commercialTapd)
        ? commercialTapd
        : teamType === 'COMMERCIAL';

      if (platForm === 'JIRA') {
        bugUrl = `${tapdBugInfo.self.substring(0, tapdBugInfo.self.indexOf('/rest'))}/browse/${tapdBugInfo.key}`;
      } else {
        bugUrl = `https://${isCommercialTapd ? 'tapd.cn' : 'tapd.woa.com'}/${workspaceId}/bugtrace/bugs/view?bug_id=${bugId}`;
      }
      return bugUrl;
    },
  });
})();
